import { CommonButton } from 'components/Buttons';
import React from 'react';
import utils from 'utils';
import { useDispatch, useSelector } from 'react-redux';
import { actionType, modalActionType } from 'utils/constants';
import selectors from 'state/selectors';
import actions from 'state/actions';

const LinkAssetId = () => {
  const records = useSelector(selectors.documents.selectAllActiveDocuments);
  const t = utils.intl.useTranslator();
  const dispatch = useDispatch();

  return (
    <CommonButton
      id="link-asset-id-btn"
      action={() => dispatch(actions.modal.openModal(modalActionType.documents.LINK_ASSET_ID))}
      scope="tertiary"
      value={t('link-asset-id')}
      disabled={!utils.user.isActionEnabled(records, actionType.LINK_ASSET_ID)}
      customIcon="paperclip"
    />
  );
};

export default LinkAssetId;
